"use client";

import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui";
import { useRouter } from "next/navigation";

interface AccessDeniedProps {
  message?: string;
  showBackButton?: boolean;
  backHref?: string;
  backLabel?: string;
}

export function AccessDenied({
  message = "Bu sayfaya erişim yetkiniz bulunmamaktadır.",
  showBackButton = true,
  backHref = "/dashboard",
  backLabel = "Ana Sayfaya Dön"
}: AccessDeniedProps) {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mb-4">
        <ShieldAlert className="w-8 h-8 text-warning" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        Erişim Engellendi
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {message}
      </p>
      {showBackButton && (
        <Button onClick={() => router.push(backHref)} variant="secondary">
          {backLabel}
        </Button>
      )}
    </div>
  );
}
